import { useState, useEffect } from 'react';
import nativeWebSocket from '../websocket-native';

/**
 * Hook para obtener el estado de conexión del WebSocket
 */
const useWebSocketStatus = () => {
  const [connectionState, setConnectionState] = useState(nativeWebSocket.getConnectionState());

  useEffect(() => {
    // Suscribirse a cambios de estado
    const unsubscribe = () => {
      nativeWebSocket.onStatusChange(setConnectionState);
    };

    unsubscribe();

    // No hay cleanup necesario ya que el websocket persiste durante toda la sesión
    return () => {};
  }, []);

  return {
    connectionState,
    isConnected: connectionState === 'connected',
    isConnecting: connectionState === 'connecting',
    isDisconnected: connectionState === 'disconnected',
    hasError: connectionState === 'error'
  };
};

export default useWebSocketStatus;